import { FC, memo } from "react";
import { VerificationAppDocumentType } from "../../../app/models";
import { TUserFullInfo } from "../../models";
import { ICompanyVerificationStatusesConfig } from "../../network";
import type { DefaultDocumentRendererProps } from "../StepAccordion/DocumentContent";
import { DefaultDocumentRenderer } from "../StepAccordion/DocumentContent";
import { EntityRepresentativesRenderer } from "./EntityRepresentativesRenderer";
import { PassportRenderer } from "./PassportRenderer";
import { SelfieRenderer } from "./SelfieRenderer";
import { UserInformationRenderer } from "./UserInformationRenderer";

export type DocumentTypeRendererProps = DefaultDocumentRendererProps & {
  userInfo?: TUserFullInfo;
  isMobile?: boolean;
  stepType?: VerificationAppDocumentType;
  statusesConfig: ICompanyVerificationStatusesConfig;
  // Optional refetch trigger used by renderers that mutate the document
  // (currently EntityRepresentativesRenderer's CO Add/Remove flows). The
  // parent screen wires this to its document loader.
  onRefreshDocuments?: () => void | Promise<void>;
  allowIdentificationEdit?: boolean;
};

function defaultRenderer(props: DocumentTypeRendererProps) {
  return <DefaultDocumentRenderer {...props} />;
}

const RENDERER_REGISTRY: Record<string, FC<DocumentTypeRendererProps>> = {
  [VerificationAppDocumentType.Passport]: PassportRenderer,
  [VerificationAppDocumentType.Id]: PassportRenderer,
  [VerificationAppDocumentType.Selfie]: SelfieRenderer,
  [VerificationAppDocumentType.UserInformation]: UserInformationRenderer,
  [VerificationAppDocumentType.EntityRepresentatives]: EntityRepresentativesRenderer,
};

export const DocumentTypeRenderer = memo((props: DocumentTypeRendererProps) => {
  const documentType = props.stepType ?? props.document.document.documentType;
  const Renderer = RENDERER_REGISTRY[documentType] ?? defaultRenderer;
  return <Renderer {...props} />;
});
